import Vue from 'vue';

import Router from 'vue-router';
Vue.use(Router);

import Site_HomePage from '../pages/site/HomePage.vue';
import Site_ContactPage from '../pages/site/ContactPage.vue';
import Site_EntreprisesPage from '../pages/site/EntreprisesPage.vue';
import Site_ScenariosPage from '../pages/site/ScenariosPage.vue';
import Site_ResultatsPage from '../pages/site/ResultatsPage.vue';
import Site_DiplomeCambridgePage from '../pages/site/DiplomeCambridgePage.vue';
//import Site_ProchainementPage from '../pages/site/ProchainementPage.vue';

import Admin_ReservationsPage from '../pages/admin/ReservationsPage.vue';
import Admin_GiftcardsPage from '../pages/admin/GiftcardsPage.vue';
import Admin_VouchercodesPage from '../pages/admin/VouchercodesPage.vue';
import Admin_NestorSessionsPage from '../pages/admin/NestorSessionsPage.vue';
import Admin_LoginPage from '../pages/admin/LoginPage.vue';
import Admin_LogoutPage from '../pages/admin/LogoutPage.vue';

const checkIfUserAuthenticated = (to, from, next) => {
  var token = localStorage.getItem('admin-token');
  if (token !== null) {
    next();
    return;
  }

  next('/admin/login');
};

const checkIfUserNotAuthenticated = (to, from, next) => {
  var token = localStorage.getItem('admin-token');
  if (token == null) {
    next();
    return;
  }

  next('/admin/reservations');
};

const router = new Router({
  routes: [
	  /*{
      path: '/',
      name: 'prochainementpage',
      component: ProchainementPage
    },*/
    {
      path: '/',
      name: 'site_homepage',
      component: Site_HomePage
    },
    {
      path: '/contact',
      name: 'site_contactpage',
      component: Site_ContactPage
    },
    {
      path: '/entreprises',
      name: 'site_entreprisespage',
      component: Site_EntreprisesPage
    },
    {
      path: '/nos-scenarios-escape-caen',
      name: 'site_scenariospage',
      component: Site_ScenariosPage
    },
    {
      path: '/resultats/nestor',
      name: 'site_resultatspage',
      component: Site_ResultatsPage
    },
    {
      path: '/diplome-cambridge',
      name: 'site_diplomecambridgepage',
      component: Site_DiplomeCambridgePage
    },
    {
      path: '/admin',
      redirect: '/admin/reservations'
    },
    {
      path: '/admin/reservations',
      name: 'admin_reservationspage',
      component: Admin_ReservationsPage,
      beforeEnter: checkIfUserAuthenticated
    },
    {
      path: '/admin/bons-cadeaux',
      name: 'admin_giftcardspage',
      component: Admin_GiftcardsPage,
      beforeEnter: checkIfUserAuthenticated
    },
    {
      path: '/admin/codes-promos',
      name: 'admin_vouchercodespage',
      component: Admin_VouchercodesPage,
      beforeEnter: checkIfUserAuthenticated
    },
    {
      path: '/admin/sessions/nestor',
      name: 'admin_nestorsessionspage',
      component: Admin_NestorSessionsPage,
      beforeEnter: checkIfUserAuthenticated
    },
    {
      path: '/admin/login',
      name: 'admin_loginpage',
      component: Admin_LoginPage,
      beforeEnter: checkIfUserNotAuthenticated
    },
    {
      path: '/admin/logout',
      name: 'admin_logoutpage',
      component: Admin_LogoutPage,
      beforeEnter: checkIfUserAuthenticated
    }
  ],
  mode: 'history'
});

export default router;
